import React from "react";

import Tweezer from "tweezer.js";

import StickyContainer from "./StickyContainer";
import ListenLive from "./ListenLive";
import WatchLive from "./WatchLive";
import ListenOrWatchLiveLinks from "./ListenOrWatchLiveLinks";

class ListenOrWatchLive extends React.Component {
  // eslint-disable-next-line react/sort-comp
  static tabs = {
    NONE: "none",
    LISTEN: "listen",
    WATCH: "watch",
  };

  radioLinks = JSON.parse(window.livePage && window.livePage.radioLinks);

  videoLinks = JSON.parse(window.livePage && window.livePage.videoLinks);

  constructor(props) {
    super(props);

    this.state = {
      tab: ListenOrWatchLive.tabs.LISTEN,
      autoplay: !!window.location.hash,
      hasWatchLive: Boolean(window.livePage.videoIframe),
    };
  }

  componentDidMount = () => {
    this.checkUrlForHash();
    window.addEventListener("hashchange", this.checkUrlForHash);
  };

  componentDidUpdate = () => {
    const { tab } = this.state;

    if (tab === ListenOrWatchLive.tabs.NONE) {
      window.onbeforeunload = null;
    } else {
      window.onbeforeunload = () => "";
    }
  };

  checkUrlForHash = () => {
    const hash = window.location.hash.replace("#", "");

    if (hash) {
      this.setState({
        tab: hash,
        autoplay: true,
      });

      const twzr = new Tweezer({
        start: window.scrollY,
        end:
          document.querySelector(".l-main").getBoundingClientRect().top +
          window.scrollY,
      });

      twzr.on("tick", (value) => {
        window.scrollTo(0, value);
      });
      twzr.begin();
    }
  };

  render = () => {
    const { tab, autoplay, hasWatchLive } = this.state;

    const listenTabActive = tab === ListenOrWatchLive.tabs.LISTEN;
    const watchTabActive = tab === ListenOrWatchLive.tabs.WATCH;

    return [
      <div className="btn-list" key="btn-list">
        <a
          className={`btn ${
            listenTabActive ? "is-active is-default" : "is-outline"
          }`}
          href={`#${ListenOrWatchLive.tabs.LISTEN}`}
        >
          <svg className="btn__icon is-prefix" width="26" height="16">
            <use xlinkHref="#live" />
          </svg>
          <span className="btn__text">luister live naar BRUZZ</span>
        </a>
        {hasWatchLive && (
          <a
            className={`btn ${
              watchTabActive ? "is-active is-default" : "is-outline"
            }`}
            href={`#${ListenOrWatchLive.tabs.WATCH}`}
          >
            <svg className="btn__icon is-prefix" width="20px" height="20px">
              <use xlinkHref="#play-button" width="20px" height="20px" />
            </svg>
            <span className="btn__text">kijk live naar BRUZZ</span>
          </a>
        )}
      </div>,
      <StickyContainer key="sticky-container">
        {listenTabActive && (
          <ListenLive autoplay={autoplay} onlyButton={!hasWatchLive} />
        )}
        {watchTabActive && <WatchLive />}
      </StickyContainer>,
      <ListenOrWatchLiveLinks
        listenTabActive={listenTabActive}
        watchTabActive={watchTabActive}
        radioLinks={this.radioLinks}
        videoLinks={this.videoLinks}
      />,
    ];
  };
}

export default ListenOrWatchLive;
